type RequestOptionsWithMethod = {
  method?: string;
};

const CSRF_COOKIE_NAME = 'vpq_csrf';
const CSRF_HEADER_NAME = 'X-CSRF-Token';
const SAFE_METHODS = new Set(['GET', 'HEAD', 'OPTIONS', 'TRACE']);

let memoryCsrfToken: string | null = null;

export function setCsrfToken(token: string | null | undefined): void {
  memoryCsrfToken = token && token.length > 0 ? token : null;
}

export function clearCsrfToken(): void {
  memoryCsrfToken = null;
}

function readCookie(name: string): string | null {
  if (typeof document === 'undefined') {
    return null;
  }

  const prefix = `${name}=`;
  const cookie = document.cookie
    .split(';')
    .map((part) => part.trim())
    .find((part) => part.startsWith(prefix));

  if (!cookie) {
    return null;
  }

  return decodeURIComponent(cookie.slice(prefix.length));
}

export function getCsrfToken(): string | null {
  return memoryCsrfToken ?? readCookie(CSRF_COOKIE_NAME);
}

export function requireCsrfTokenParameter(): string {
  const token = getCsrfToken();
  if (!token) {
    throw new Error('csrf token is missing');
  }
  return token;
}

export function isUnsafeMethod(method: string | undefined): boolean {
  if (!method) {
    return false;
  }

  return !SAFE_METHODS.has(method.toUpperCase());
}

export async function csrfHeaderResolver(
  options: RequestOptionsWithMethod,
): Promise<Record<string, string>> {
  if (!isUnsafeMethod(options.method)) {
    return {};
  }

  const token = getCsrfToken();
  return token ? { [CSRF_HEADER_NAME]: token } : {};
}
